import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const useFetchSubscriptions = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { getAccessTokenSilently } = useAuth0();
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    let isMounted = true;

    const populateSubscriptionsData = async () => {
      setLoading(true);
      setError("");
      try {
        const token = await getAccessTokenSilently({
          authorizationParams: {
            audience:process.env.REACT_APP_API_AUDIENCE,
          },
        });

        const response = await fetch(`${apiUrl}/api/subscriptions`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const subscriptions = await response.json();

          const groupRequests = subscriptions.map(async (subscription) => {
            if (subscription.groupName) {
              return subscription;
            }

            const groupResponse = await fetch(`${apiUrl}/api/GroupsTbls/${subscription.groupId}`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });

            if (groupResponse.ok) {
              const groupData = await groupResponse.json();
              return { ...subscription, groupName: groupData.groupName };
            }

            return subscription;
          });

          // Wait for all group name requests to complete
          const subscriptionsWithData = await Promise.all(groupRequests);

          if (isMounted) {
            setSubscriptions(subscriptionsWithData);
          }
        } else {
          console.error('Failed to fetch subscriptions:', response.statusText);
          if (isMounted) {
            setSubscriptions([]);
            setError(`Memberships could not be loaded (${response.status}).`);
          }
        }
      } catch (error) {
        console.error('Error fetching subscriptions:', error.message);
        if (isMounted) {
          setSubscriptions([]);
          setError(error.message || "Memberships could not be loaded.");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    populateSubscriptionsData();

    return () => {
      isMounted = false;
    };
  }, [apiUrl, getAccessTokenSilently]);

  return { subscriptions, loading, error };
};

